module.exports = __webpack_public_path__ + "media/killedEnemy.f007e368.ogg";